module.exports = __webpack_public_path__ + "img/section3-img1.2343a5a9.png";